import React from 'react';
import { Box, Container, Typography, useTheme, useMediaQuery } from '@mui/material';

interface HeroSectionProps {
  children?: React.ReactNode;
}

export const HeroSection: React.FC<HeroSectionProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: 'url("https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1920&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden',
      }}
    >
      {/* Dark gradient overlay for legibility */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.35), rgba(0,0,0,0.5))',
          zIndex: 1,
        }}
      />

      {/* Hero content */}
      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
          px: { xs: 2, md: 3 },
        }}
      >
        <Typography
          variant={isMobile ? 'h3' : 'h2'}
          component="h1"
          sx={{
            fontWeight: 700,
            color: '#ffffff',
            mb: 2,
            animation: 'fadeInUp 600ms ease-out forwards',
            opacity: 0,
          }}
        >
          Find your perfect stay
        </Typography>

        <Typography
          variant={isMobile ? 'body1' : 'h6'}
          sx={{
            color: 'rgba(255,255,255,0.9)',
            mb: 5,
            maxWidth: 560,
            mx: 'auto',
            fontWeight: 400,
            lineHeight: 1.6,
            animation: 'fadeInUp 600ms ease-out forwards',
            animationDelay: '100ms',
            opacity: 0,
          }}
        >
          Discover unique places to stay around the world
        </Typography>

        {/* Search bar slot */}
        <Box
          sx={{
            maxWidth: 850,
            mx: 'auto',
            animation: 'fadeInUp 600ms ease-out forwards',
            animationDelay: '200ms',
            opacity: 0,
          }}
        >
          {children}
        </Box>
      </Container>
    </Box>
  );
};
